import React from 'react';
import { Link } from 'react-router-dom';

import PublicSiteShell from './PublicSiteShell.jsx';
import { appUrl } from '../../lib/hosts.js';

const packages = [
  {
    name: '标准套餐',
    tag: '适合试用和小团队起步',
    text: '覆盖客户、产品、报价、成本、退税、审批和 PDF 交付的基础链路，帮助团队先跑通第一套真实报价流程。',
    points: ['核心报价链路', '基础客户与产品库', '角色权限与审批留痕']
  },
  {
    name: '进阶套餐',
    tag: '适合工贸一体和高频报价团队',
    text: '在标准能力上加强成本拆解、利润测算、报价复盘和团队协作，适合报价频率高、产品成本更复杂的企业。',
    points: ['成本与毛利分析', '报价复盘', '更完整的团队协作']
  },
  {
    name: '企业扩展',
    tag: '适合多主体、多角色和深度实施',
    text: '面向更复杂的组织结构、更多使用席位和更细的业务口径，支持按实际经营场景扩展系统能力。',
    points: ['更多角色与席位', '经营数据沉淀', '实施服务可单独评估']
  }
];

const serviceItems = [
  ['年度套餐', '按企业选择的产品版本开通，先完成核心链路试用，再按经营复杂度升级。'],
  ['席位扩容', '财务和业务等协作角色可按需增加席位，避免一开始购买过重配置。'],
  ['模板实施', '客户原 Excel 模板迁移、个性化报价模板和行业口径适配属于实施服务，可单独报价。']
];

export default function Pricing() {
  return (
    <PublicSiteShell>
      <section className="bg-[#f7f3ec]">
        <div className="mx-auto grid max-w-6xl gap-10 px-6 py-16 lg:grid-cols-[1fr_.9fr] lg:items-center">
          <div>
            <p className="text-sm font-semibold text-chango-700">PRICING</p>
            <h1 className="mt-4 text-4xl font-semibold leading-tight text-slate-950 sm:text-5xl">
              清晰的版本，按企业阶段开通。
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-700">
              长戈采用年度套餐、席位扩容和实施服务相结合的方式。企业可以先从出口决策云的核心能力试用，再根据产品复杂度、人员规模和模板适配深度逐步扩展。
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href={appUrl('/register')} className="rounded-md bg-slate-950 px-5 py-3 text-sm font-semibold text-white hover:bg-slate-800">
                进入系统选择试用
              </a>
              <Link to="/product" className="rounded-md border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-slate-900 hover:bg-slate-50">
                查看产品能力
              </Link>
            </div>
          </div>
          <div className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
            <div className="text-sm font-semibold text-slate-950">计费原则</div>
            <div className="mt-5 grid gap-4">
              {serviceItems.map(([title, text]) => (
                <div key={title} className="border-l-2 border-chango-600 pl-4">
                  <div className="text-sm font-semibold text-slate-900">{title}</div>
                  <div className="mt-1 text-sm leading-6 text-slate-600">{text}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="mx-auto max-w-6xl px-6">
          <div className="mb-8 max-w-3xl">
            <p className="text-sm font-semibold text-amber-700">版本选择</p>
            <h2 className="mt-2 text-3xl font-semibold text-slate-950">先匹配业务复杂度，再决定采购深度。</h2>
            <p className="mt-4 text-sm leading-7 text-slate-600">
              官网展示版本结构，实际套餐、有效期、优惠和可用模块以系统内实时价目为准。
            </p>
          </div>
          <div className="grid gap-5 lg:grid-cols-3">
            {packages.map((item, idx) => (
              <article
                key={item.name}
                className={[
                  'rounded-lg border p-6 shadow-sm',
                  idx === 1 ? 'border-slate-950 bg-slate-950 text-white' : 'border-slate-200 bg-white text-slate-950'
                ].join(' ')}
              >
                <div className={idx === 1 ? 'text-sm font-semibold text-amber-300' : 'text-sm font-semibold text-chango-700'}>
                  {item.tag}
                </div>
                <h3 className="mt-3 text-xl font-semibold">{item.name}</h3>
                <p className={['mt-4 min-h-[6.5rem] text-sm leading-7', idx === 1 ? 'text-slate-300' : 'text-slate-600'].join(' ')}>
                  {item.text}
                </p>
                <ul className="mt-5 grid gap-2 text-sm">
                  {item.points.map((point) => (
                    <li key={point} className="flex items-center gap-2">
                      <span className={['h-1.5 w-1.5 rounded-full', idx === 1 ? 'bg-amber-300' : 'bg-chango-600'].join(' ')} />
                      <span className={idx === 1 ? 'text-slate-100' : 'text-slate-700'}>{point}</span>
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>
    </PublicSiteShell>
  );
}
